class CartTool extends HTMLElement {
  constructor() {
    super();
    const buttons = this.querySelectorAll('.cartTool-item');
    buttons.forEach((button) => {
      button.addEventListener('click',(event) => {
        const id = event.target.dataset.popup;
        document.getElementById(id).classList.add('show');
        document.querySelector('.previewCart').classList.add('active-tool');
      })
    })
  }
}

customElements.define('cart-item-tool', CartTool);

class CartCancel extends HTMLElement {
  constructor() {
    super();
    
    this.querySelector('button').addEventListener('click',(event) => {
      document.querySelector('.popup-toolDown.show').classList.remove('show');
      document.querySelector('.previewCart').classList.remove('active-tool');
    })
  }
}

customElements.define('cart-cancel-popup', CartCancel);

class CartNote extends HTMLElement {
  constructor() {
    super();
    
    this.querySelector('[data-update-note]').addEventListener('click', (event) => {
      this.val = this.querySelector('.text-area').value;
      const body = JSON.stringify({ note: this.val });
      fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      document.querySelector('.popup-toolDown.show').classList.remove('show');
      document.querySelector('.previewCart').classList.remove('active-tool');
    })
  }
}

customElements.define('cart-note', CartNote);

class CouponCode extends HTMLElement {
  constructor() {
    super();
    if (localStorage.getItem('storedDiscount')){
      this.querySelector('input[name="discount"]').value = localStorage.getItem('storedDiscount');  
    }
    this.querySelector('[data-update-coupon]').addEventListener('click', (event) => {
      this.val = this.querySelector('input[name="discount"]').value;
      localStorage.setItem('storedDiscount', this.val);
      fetch(`/discount/${this.val}`)
          .then((response) => response.text())
          .then((responseText) => {
            Shopify.getCart((cart) => {window.sharedFunctions?.updateSidebarCart(cart)});
          });
      document.querySelector('.popup-toolDown.show').classList.remove('show');
      document.querySelector('.previewCart').classList.remove('active-tool');
    })
  }
}

customElements.define('coupon-code', CouponCode);

(() => {
  const sidebar = document.getElementById('halo-cart-sidebar');
  const header = sidebar?.querySelector('.halo-sidebar-header');

  if (!sidebar || !header || sidebar.dataset.headerShadowBound === 'true') return;

  sidebar.dataset.headerShadowBound = 'true';

  const updateHeaderShadow = (scroller) => {
    header.classList.toggle('is-stuck', Boolean(scroller && scroller.scrollTop > 0));
  };

  const updateRecommendationSlider = () => {
    const slider = sidebar.querySelector('.previewCartCarousel.slick-initialized');

    if (slider && window.jQuery?.fn?.slick) {
      window.jQuery(slider).slick('setPosition');
    }
  };

  sidebar.addEventListener('scroll', (event) => {
    if (event.target.matches?.('.previewCart')) {
      updateHeaderShadow(event.target);
    }
  }, true);

  document.addEventListener('cart-update', () => {
    requestAnimationFrame(() => {
      updateHeaderShadow(sidebar.querySelector('.previewCart'));
      updateRecommendationSlider();
    });
  });

  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-cart-sidebar], [data-close-cart-sidebar]')) {
      header.classList.remove('is-stuck');
    }

    if (event.target.closest('[data-cart-sidebar]')) {
      requestAnimationFrame(updateRecommendationSlider);
    }
  });
})();

(() => {
  const recommendationFormSelector = '[data-cart-recommendation-form]';

  document.addEventListener('change', (event) => {
    const selector = event.target.closest('[data-cart-recommendation-variant]');
    if (!selector || selector.tagName !== 'SELECT') return;

    const form = selector.closest(recommendationFormSelector);
    const selectedOption = selector.options[selector.selectedIndex];
    const card = form?.closest('.cart-recommendation-card');
    const price = card?.querySelector('[data-cart-recommendation-price]');
    const image = card?.querySelector('[data-cart-recommendation-image]');
    const addButton = form?.querySelector('[data-cart-recommendation-add]');

    if (price && selectedOption.dataset.price) {
      price.textContent = selectedOption.dataset.price;
    }

    if (image && selectedOption.dataset.image) {
      image.src = selectedOption.dataset.image;
      image.srcset = '';
      image.alt = selectedOption.dataset.imageAlt || image.alt;
    }

    if (addButton) {
      addButton.disabled = selectedOption.dataset.available !== 'true';
    }
  });

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest(recommendationFormSelector);
    if (!form) return;

    event.preventDefault();

    const addButton = form.querySelector('[data-cart-recommendation-add]');
    const variantInput = form.querySelector('[data-cart-recommendation-variant]');
    const errorMessage = form.querySelector('[data-cart-recommendation-error]');
    const variantId = Number(variantInput?.value);

    if (!variantId || addButton?.disabled) return;

    if (errorMessage) {
      errorMessage.hidden = true;
      errorMessage.textContent = '';
    }

    addButton.disabled = true;
    addButton.classList.add('is-loading');
    addButton.setAttribute('aria-busy', 'true');

    try {
      const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          items: [{ id: variantId, quantity: 1 }]
        })
      });
      const result = await response.json();

      if (!response.ok) {
        throw new Error(result.description || result.message || window.cartStrings?.cartErrorMessage || 'Unable to add this item.');
      }

      Shopify.getCart((cart) => {
        document.body.classList.add('cart-sidebar-show');
        window.sharedFunctions?.updateSidebarCart(cart);
      });
    } catch (error) {
      if (errorMessage) {
        errorMessage.textContent = error.message;
        errorMessage.hidden = false;
      }

      addButton.disabled = false;
      addButton.classList.remove('is-loading');
      addButton.removeAttribute('aria-busy');
    }
  });
})();
